// extracted by mini-css-extract-plugin
module.exports = {"NoData":"style_NoData__IKDv2","artwork":"style_artwork__XRPij","two_line_ellipsis":"style_two_line_ellipsis__tYvIM"};